import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Aarogyam, Iilds, Karad, Medikal, MK, Nepal, Tata, Turkish, webapi} from '../../shared/my-constants';
import {Http, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {TinvPharmacySaleService} from '../../inventory/tinv-pharmacy-sale/tinv-pharmacy-sale.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
    private logoutUrl = webapi + 'login_logout_trail/logout/?';
    unitName: any;
// user permission :by vijay
    userAccess: Array<any> = [];
    currentUseraction: Array<any> = [];
    currentUserdetails: any;
    smAppointmentNew: boolean;
    smAppointmentList: boolean;
    smRegistration: boolean;
    smRegistrationList: boolean;
    smDashboard: boolean;
    smQueue: boolean;
    smOPDBill: boolean;
    smBillList: boolean;
    uaIPD: boolean;
    uaNursingConsole: boolean;
    uaShortEMR: boolean;
    smEmrPatReg: boolean;
    smEmrPatQueue: boolean;
    smEmrPatList: boolean;
    smChangePassword: boolean;

    currentUseractionemrper: Array<any> = [];
    iilds: Boolean = Iilds;
    nepal: Boolean = Nepal;
    tata: Boolean = Tata;
    aarogyam: Boolean = Aarogyam;
    turkish: Boolean = Turkish;
    medikal: Boolean = Medikal;
    mk: Boolean = MK;
    karad: Boolean = Karad;
    nursingIndentCount: any =2;
    private alive: boolean;

    constructor(private router: Router, private http: Http,  private tinvPharmacySaleService: TinvPharmacySaleService) {
    }

    ngOnInit() {


        //console.log("Starting sessionStorage override...");
        (function() {
        function logSessionStorageContents() {
            //console.log("Checking sessionStorage contents...");
            if (sessionStorage.length === 0) {
                //console.log("sessionStorage is empty.");
            } else {
                for (let i = 0; i < sessionStorage.length; i++) {
                    const key = sessionStorage.key(i);
                    const value = sessionStorage.getItem(key);
                    //console.log(`sessionStorage contains - ${key}: ${value}`);
                }
            }
        }

        logSessionStorageContents();
        function syncSessionToLocalStorage() {
            //console.log("Starting sync from sessionStorage to localStorage...");
            const keys = Object.keys(sessionStorage);
            if (keys.length === 0) {
                //console.log("No data in sessionStorage to sync.");
            } else {
                keys.forEach((key) => {
                    const value = sessionStorage.getItem(key);
                    localStorage.setItem(key, value);
                    //console.log(`Copied ${key}: ${value} from sessionStorage to localStorage.`);
                });
            }
            //console.log("Sync from sessionStorage to localStorage complete.");
        }

        syncSessionToLocalStorage();

        // Copy all localStorage data to sessionStorage on page load
        function loadLocalStorageToSessionStorage() {
            //console.log("Loading data from localStorage to sessionStorage...");
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                const value = localStorage.getItem(key);
                sessionStorage.setItem(key, value);
                //console.log(`Copied ${key}: ${value} from localStorage to sessionStorage.`);
            }
            //console.log("Data from localStorage loaded into sessionStorage.");
        }

        loadLocalStorageToSessionStorage();

        //console.log("Inside sessionStorage override function");

        // Store original methods
        const originalSetItem = sessionStorage.setItem;
        const originalGetItem = sessionStorage.getItem;
        const originalRemoveItem = sessionStorage.removeItem;
        const originalClear = sessionStorage.clear;

        sessionStorage.setItem = function(key, value) {
            //console.log(`Redirecting sessionStorage.setItem to localStorage for key: ${key}`);
            localStorage.setItem(key, value);
        };

        sessionStorage.getItem = function(key) {
            //console.log(`Redirecting sessionStorage.getItem to localStorage for key: ${key}`);
            return localStorage.getItem(key);
        };

        sessionStorage.removeItem = function(key) {
            //console.log(`Redirecting sessionStorage.removeItem to localStorage for key: ${key}`);
            localStorage.removeItem(key);
        };

        sessionStorage.clear = function() {
            //console.log("Redirecting sessionStorage.clear to localStorage");
            localStorage.clear();
        };
        })();

        //console.log("sessionStorage override complete.");

        this.unitName = sessionStorage.getItem('unitName');
        this.currentUserdetails = JSON.parse(sessionStorage.getItem('userdetail'));
        this.userAccess = JSON.parse(sessionStorage.getItem('useraction'));
        this.currentUseraction = JSON.parse(sessionStorage.getItem('useraction'));
        if (this.currentUserdetails == null) {
            this.router.navigate(['']);
        }
        // this.alive = true;  Code for notification by gayatri
        // Observable.timer(0,5000)
        //     .takeWhile(() => this.alive) // only fires when component is alive
        //     .subscribe(() => {
        //         this.tinvPharmacySaleService.getAllNursingRequest().then(resp => {
        //             console.log('All Requsets', resp.totalElements);
        //             this.nursingIndentCount = resp.totalElements;
        //         });
        //     });
        this.loadUserSubModule();
    }

    logoutaction() {
        sessionStorage.clear();
        localStorage.clear();
        this.router.navigate(['']);
        let login_json = JSON.parse(sessionStorage.getItem('login_json'));
        login_json.lltLogoutDate = new Date();
        let headers = new Headers({'Content-Type': 'application/json'});
        return this.http.post(this.logoutUrl, JSON.stringify(login_json), {headers: headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }

    loadUserSubModule() {
        for (let ua of this.userAccess) {
            if (ua.aurActionModuleName == 'OPD' && ua.aurActionSubModuleName == 'Appointment New') {
                this.smAppointmentNew = true;
            }
            if (ua.aurActionModuleName == 'OPD' && ua.aurActionSubModuleName == 'Appointment List') {
                this.smAppointmentList = true;
            }
            if (ua.aurActionModuleName == 'OPD' && ua.aurActionSubModuleName == 'Registration') {
                this.smRegistration = true;
            }
            if (ua.aurActionModuleName == 'OPD' && ua.aurActionSubModuleName == 'Registration List') {
                this.smRegistrationList = true;
            }
            if (ua.aurActionModuleName == 'OPD' && ua.aurActionSubModuleName == 'Queue') {
                this.smQueue = true;
            }
            if (ua.aurActionModuleName == 'Billing' && ua.aurActionSubModuleName == 'OPD Bill') {
                this.smOPDBill = true;
            }
            if (ua.aurActionModuleName == 'Billing' && ua.aurActionSubModuleName == 'Bill List') {
                this.smBillList = true;
            }
            if (ua.aurActionModuleName == 'IPD') {
                this.uaIPD = true;
            }
            if (ua.aurActionModuleName == 'Nursing Station') {
                this.uaNursingConsole = true;
            }
            if (ua.aurActionModuleName == 'MIS' && ua.aurActionSubModuleName == 'Dashboard') {
                this.smDashboard = true;
            }
            if (ua.aurActionSubModuleName == 'EMR Patient Registration' && ua.aurActionModuleName == 'ShortEMR') {
                this.smEmrPatReg = true;
            }
            if (ua.aurActionSubModuleName == 'EMR Patient Queue' && ua.aurActionModuleName == 'ShortEMR') {
                this.smEmrPatQueue = true;
            }
            if (ua.aurActionSubModuleName == 'EMR Patient List' && ua.aurActionModuleName == 'ShortEMR') {
                this.smEmrPatList = true;
            }
            if (ua.aurActionSubModuleName == 'Change Password' && ua.aurActionModuleName == 'Change Password') {
                this.smChangePassword = true;
            }
        }
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/layout/header/header.component.ts